import { render, staticRenderFns } from "./ReceiptBlock.vue?vue&type=template&id=23060dcc&scoped=true&"
import script from "./ReceiptBlock.vue?vue&type=script&lang=js&"
export * from "./ReceiptBlock.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptBlock.vue?vue&type=style&index=0&id=23060dcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23060dcc",
  null
  
)

export default component.exports